import { ProductWithVariantsStock } from '@/types/product-type';

export type StockStatus = 'In Stock' | 'Low Stock' | 'Out of Stock';

export interface ProductStockStats {
  totalStockInHand: number;
  totalSold: number;
  variantCount: number;
  stockStatus: StockStatus;
}

export function calculateProductStockStats(
  product: ProductWithVariantsStock,
): ProductStockStats {
  const totalStockInHand = product.variants.reduce(
    (sum, v) => sum + (v.stockInHand ?? 0),
    0,
  );
  const totalSold = product.variants.reduce((sum, v) => sum + (v.soldQty ?? 0), 0);
  const variantCount = product.variants.length;

  // Determine stock status
  let stockStatus: StockStatus = 'In Stock';
  if (totalStockInHand <= 0) {
    stockStatus = 'Out of Stock';
  } else if (totalStockInHand < 10) {
    stockStatus = 'Low Stock';
  }

  return {
    totalStockInHand,
    totalSold,
    variantCount,
    stockStatus,
  };
}
